export const TENANT_ID = 'absa'
